(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sh-shop-the-outfit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.shOutfitBound) return;
    window.shOutfitBound = true;
    const revisions = new WeakMap();
    const update = (picker) => {
      if (!picker?.isConnected || !picker.hasAttribute('data-update-url')) return;
      let variant;
      try { variant = JSON.parse(picker.querySelector('[data-kit-selected-variant]')?.textContent || 'null'); } catch { return; }
      document.querySelectorAll('[data-sh-outfit-source]').forEach(section => {
        if (section.dataset.shOutfitSource !== picker.dataset.productId) return;
        const groups = [...section.querySelectorAll('[data-sh-outfit-group]')];
        if (groups.length > 1 && !variant) {
          section.hidden = true;
          section.removeAttribute('aria-busy');
          return;
        }
        const color = variant?.options?.[Number(section.dataset.shOutfitColorIndex)];
        const active = groups.find(group => group.dataset.shOutfitGroup === color) || groups.find(group => group.dataset.shOutfitGroup === 'default');
        groups.forEach(group => { group.hidden = group !== active; });
        section.hidden = !active?.querySelector('[data-sh-outfit-product]');
        section.removeAttribute('aria-busy');
      });
    };
    document.addEventListener('shopify:product:select', event => {
      const picker = event.target;
      if (!picker.matches?.('kit-variant-picker[data-update-url]')) return;
      const revision = (revisions.get(picker) || 0) + 1;
      revisions.set(picker, revision);
      document.querySelectorAll('[data-sh-outfit-source]').forEach(section => {
        if (section.dataset.shOutfitSource === picker.dataset.productId) section.setAttribute('aria-busy', 'true');
      });
      Promise.resolve(event.promise).then(() => {
        if (revisions.get(picker) === revision) update(picker);
      }, () => {
        if (revisions.get(picker) === revision) update(picker);
      });
    });
    const refresh = () => document.querySelectorAll('kit-variant-picker[data-update-url]').forEach(update);
    document.addEventListener('shopify:section:load', refresh);
    window.addEventListener('pageshow', refresh);
    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
